module.exports = __webpack_public_path__ + "img/ertong_code.cf96fed2.png";